import React, {Component} from 'react';
import {Navbar, Page} from 'framework7-react';

import './GeneralCheckPage.css';
import GeneralCheckQuestion from "../../generalCheckQuestion/GeneralCheckQuestion";
import GeneralCheckCategoryCard from "../../generalCheckCategoryCard/GeneralCheckCategoryCard";
import GeneralChecksModel from "../../../model/GeneralChecksModel";
import PrimaryButton from "../../primaryButton/PrimaryButton";
import generalChecksModel from "../../../model/GeneralChecksModel";

export default class GeneralCheckPage extends Component {
	constructor(props) {
		super(props);
		this.state = {categoriesArray: []}
	}

	openQuestions = (categoryId) => {
		this.questionPopup.open(categoryId);
	};
	update = () => {
		this.setState({categoriesArray: GeneralChecksModel.categoriesArray()});
	}

	async componentDidMount() {
		this.update();
		this.subId = GeneralChecksModel.onChange(this.update);
		await GeneralChecksModel.initialize(this.props.generalCheckId);
	}

	componentWillUnmount() {
		generalChecksModel.unsubscribe(this.subId);
	}

	submit = async () => {
		await generalChecksModel.submit();

		this.props.onBackClick();
	};

	render() {
		return (
			<Page className="g-general-check-page">
				<Navbar backLink="Back" title={this.props.name} onBackClick={this.props.onBackClick}/>
				<div className={'content'}>
					{this.state?.categoriesArray.map((category) => {
						return <GeneralCheckCategoryCard category={category} onContinue={this.openQuestions}/>
					})}
				</div>
				{this.state?.categoriesArray?.length && <PrimaryButton className={'done-button'} center onClick={this.submit}>Done</PrimaryButton>}
				<GeneralCheckQuestion ref={ref => this.questionPopup = ref}/>
			</Page>
		)
	}
}